import React from "react";

const About = () => {
  return (
    <div className="bg-[#fdf7f7]">
      {/* 🔹 Hero Section */}
      <section className="relative h-[60vh] flex items-center justify-center text-white">
        <img
          src="https://images.unsplash.com/photo-1496661415325-ef852f9e8e7c?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w4NDk1NzN8MHwxfHNlYXJjaHwxfHx3ZWRkaW5nJTIwYmFubmVyfGVufDB8fHx8MTc3MTA1NTg0MHww&ixlib=rb-4.1.0&q=80&w=400"
          alt="About Hero"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/50"></div>

        <div className="relative text-center px-6">
          <h1 className="text-4xl md:text-6xl font-serif mb-4">
            About <span className="text-[#b76d68]">Wedding Stays</span>
          </h1>
          <p className="max-w-2xl mx-auto text-lg">
            WeddingStays is a managed wedding accommodation company that
            transforms ordinary hotels into fully structured, guest-ready
            wedding residences
          </p>
        </div>
      </section>

      {/* 🔹 Our Story */}
      <section className="py-20 max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
        <img
          src="https://images.unsplash.com/photo-1522673607200-164d1b6ce486"
          alt="Our Story"
          className="rounded-2xl shadow-lg"
        />

        <div>
          <h2 className="text-3xl font-serif mb-6 text-gray-800">Our Story</h2>
          <p className="text-gray-600 leading-relaxed mb-4">
            Our Story Indian weddings are beautiful — but guest accommodation is
            often chaotic and unstructured. We saw families juggling room lists,
            transport calls, and guest complaints during moments meant for
            celebration.
          </p>
          <p className="text-gray-600 leading-relaxed">
            WeddingStays was created to bring planning, accountability, and
            premium hospitality to where your guests live during your most
            important days.
          </p>
        </div>
      </section>

      {/* 🔹 Mission & Vision */}
      <section className="bg-white py-20">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-10 text-center">
          <div className="p-8 shadow-md rounded-2xl">
            <h3 className="text-2xl font-serif text-[#b76d68] mb-4">
              Our Mission
            </h3>
            <p className="text-gray-600">
              To deliver seamless, well-managed, and personalized wedding stays
              that allow families to celebrate without worrying about guest
              logistics
            </p>
          </div>

          <div className="p-8 shadow-md rounded-2xl">
            <h3 className="text-2xl font-serif text-[#b76d68] mb-4">
              Our Vision
            </h3>
            <p className="text-gray-600">
              To become India’s most trusted platform for curated and
              professionally managed group stays, starting with weddings.
            </p>
          </div>
        </div>
      </section>

      {/* 🔹 Why Choose Us */}
      <section className="py-20 max-w-6xl mx-auto px-6 text-center">
        <h2 className="text-3xl font-serif mb-12 text-gray-800">
          Why Choose Us?
        </h2>

        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-white p-8 rounded-2xl shadow-md">
            <h4 className="text-xl font-semibold mb-3 text-[#b76d68]">
              Curated Venues
            </h4>
            <p className="text-gray-600">
              Handpicked luxury venues across India’s most iconic destinations.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-md">
            <h4 className="text-xl font-semibold mb-3 text-[#b76d68]">
              Expert Planning
            </h4>
            <p className="text-gray-600">
              Dedicated wedding specialists ensuring flawless execution.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-md">
            <h4 className="text-xl font-semibold mb-3 text-[#b76d68]">
              Transparent Pricing
            </h4>
            <p className="text-gray-600">
              No hidden costs — complete clarity from booking to celebration.
            </p>
          </div>
        </div>
      </section>

      {/* 🔹 Call To Action */}
      {/* <section className="bg-[#b76d68] text-white py-16 text-center">
        <h2 className="text-3xl font-serif mb-6">
          Let’s Plan Your Dream Wedding
        </h2>
        <button className="bg-white text-[#b76d68] px-8 py-3 rounded-md font-medium hover:bg-gray-100 transition">
          Get Free Consultation
        </button>
      </section> */}
    </div>
  );
};

export default About;
